import React, { useEffect } from "react";
import { Header, Button, Card, Container, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { verificarDisponibilidadPago } from "../../../../app/store/actions/pagoActions";
import UsuarioSinClaveDobleFactorMessage from "../../../../app/common/messages/UsuarioSinClaveDobleFactorMessage";
import { getClaveDobleFactorUsuario } from "./../../../../app/store/actions/transactionalActions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ServicioNoDisponibleMessage from "../../../../app/common/messages/ServicioNoDisponibleMessage";
import { esListaNoVacia } from "../../../../app/util/arrayUtils";

const mapState = (state) => ({
  claveDobleFactorUsuario: state.transactionalReducer.claveDobleFactorUsuario,
  loadingClaveDobleFactorUsuario:
    state.transactionalReducer.loadingClaveDobleFactorUsuario,
  currentUser: state.auth.currentUser,
  loadingDisponibilidadPago: state.pagoReducer.loadingDisponibilidadPago,
  disponibilidadPago: state.pagoReducer.disponibilidadPago,
});

const actions = {
  getClaveDobleFactorUsuario,
  verificarDisponibilidadPago,
};

const TransferenciasPage = ({
  currentUser,
  getClaveDobleFactorUsuario,
  claveDobleFactorUsuario,
  loadingClaveDobleFactorUsuario,
  verificarDisponibilidadPago,
  loadingDisponibilidadPago,
  disponibilidadPago,
}) => {
  //useEffect
  useEffect(() => {
    if (currentUser?.username) {
      getClaveDobleFactorUsuario();
    }
  }, [getClaveDobleFactorUsuario, currentUser]);

  useEffect(() => {
    if (currentUser?.username) {
      verificarDisponibilidadPago();
    }
  }, [verificarDisponibilidadPago, currentUser]);

  //loadings
  if (loadingClaveDobleFactorUsuario || !claveDobleFactorUsuario)
    return <LoadingComponent content="Cargando información..." />;

  if (loadingDisponibilidadPago)
    return <LoadingComponent content="Consultando disponibilidad de pago..." />;

  return (
    <Container className="containerPrincipal" textAlign="center">
      <Header
        as="h1"
        content="Realiza tus transferencias"
        color="blue"
        textAlign="center"
      />
      <Header
        as="h3"
        content="Elige el tipo de transferencia:"
        color="blue"
        textAlign="center"
      />
      <Card.Group centered>
        <Card>
          <Card.Content>
            <Header icon>
              <Icon name="credit card" size="big" color="yellow" />
            </Header>
            <Card.Meta>
              <span className="date">
                Transferir entre mis propias cuentas.
              </span>
            </Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <div className="ui one buttons center">
              <Button
                as={Link}
                to="/transferencias-cuentas-propias"
                basic
                color="blue"
                content="Entre mis cuentas"
                disabled={!disponibilidadPago}
              />
            </div>
          </Card.Content>
        </Card>
        <Card>
          <Card.Content>
            <Header icon>
              <Icon name="users" size="big" color="yellow" />
            </Header>
            <Card.Meta>
              <span className="date">
                Transferir a otras cuentas de Prymera.
              </span>
            </Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <div className="ui one buttons">
              <Button
                as={Link}
                to="/transferencias-cuentas-prymera"
                basic
                color="blue"
                content="A otras cuentas Prymera"
                disabled={
                  !esListaNoVacia(claveDobleFactorUsuario.lista) ||
                  !disponibilidadPago
                }
              />
            </div>
          </Card.Content>
        </Card>
        <Card>
          <Card.Content>
            <Header icon>
              <Icon name="building outline" size="big" color="yellow" />
            </Header>
            <Card.Meta>
              <span className="date">Transferir a otros bancos.</span>
            </Card.Meta>
          </Card.Content>
          <Card.Content extra>
            <div className="ui one buttons">
              <Button
                as={Link}
                to="/transferencias-cuentas-ifis"
                basic
                color="blue"
                content="A otros bancos"
                disabled={
                  !esListaNoVacia(claveDobleFactorUsuario.lista) ||
                  !disponibilidadPago
                }
              />
            </div>
          </Card.Content>
        </Card>
      </Card.Group>
      <br />
      {!esListaNoVacia(claveDobleFactorUsuario.lista) && (
        <UsuarioSinClaveDobleFactorMessage />
      )}
      <br />
      {!disponibilidadPago && <ServicioNoDisponibleMessage />}
    </Container>
  );
};

TransferenciasPage.propTypes = {
  getClaveDobleFactorUsuario: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  claveDobleFactorUsuario: PropTypes.object,
  loadingClaveDobleFactorUsuario: PropTypes.bool.isRequired,
  verificarDisponibilidadPago: PropTypes.func.isRequired,
  loadingDisponibilidadPago: PropTypes.bool.isRequired,
};

export default connect(mapState, actions)(TransferenciasPage);
